// Copyright (c) 2021-2024 Broadcom. All Rights Reserved.
// Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
// and/or its subsidiaries.

import { APP_INITIALIZER, NgModule, Provider, provideZoneChangeDetection } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "@shared/shared.module";
import { CspApiService, CspComponentsModule, CspTokenService } from "@vmw/csp-ngx-components";
import { CspHeaderModule } from "@vmw/csp-ngx-components/header";
import { LocaleService, VIPModule, VIPService } from "@vmw/ngx-vip";
import { VmwContextualHelpModule } from "@vmw/ngx-contextual-help";
import { OAuth2Module, OAuth2TokenSubject } from "@vmw/ngx-csp-oauth2";
import { OAuth2Client } from "@vmw/csp-oauth2";
import { AppConfigService, AuthConfigurationProvider, httpInterceptorProviders, loadUserData } from "@app/services";
import { initLocale } from "@app/resources/i18n/i18n.config";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { FormsModule } from "@angular/forms";

const MODULES: any[] = [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CspComponentsModule.forRoot(),
    VmwContextualHelpModule.forRoot(),
    VIPModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    OAuth2Module,
    CspHeaderModule,
    SharedModule
];

const PROVIDERS: Provider[] = [
    CspTokenService,
    httpInterceptorProviders,
    AuthConfigurationProvider,
    {
        // Blocking loading of strings - suitable for up to 5000 strings
        provide: APP_INITIALIZER,
        useFactory: initLocale,
        deps: [
            VIPService,
            LocaleService,
            CspApiService,
            AppConfigService
        ],
        multi: true
    },
    {
        // Blocking app loading until logged in user and current org are detected
        provide: APP_INITIALIZER,
        useFactory: loadUserData,
        deps: [
            OAuth2TokenSubject,
            OAuth2Client
        ],
        multi: true
    },      
    provideZoneChangeDetection({ eventCoalescing: true }) as unknown as Provider
];

// @formatter:off
@NgModule({
    imports: [MODULES],
    declarations: [AppComponent],
    providers: [PROVIDERS],
    bootstrap: [AppComponent]
})
// @formatter:on

export class AppModule {
}
